import PropTypes from "prop-types"
import React, { useState } from "react"
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"

// Components
import UploadSection from "./UploadSection"
import DeleteSection from "./DeleteSection"
import StatsCards from "./StatsCards" // ← Added import (adjust path if needed)

// Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// i18n
import { withTranslation } from "react-i18next"

const ReportManager = props => {
  // Page title
  document.title = props.t("Report Manager") + " | Your App Name"

  const [activeTab, setActiveTab] = useState("1")

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumb */}
          <Breadcrumbs
            title={props.t("Reports")}
            breadcrumbItem={props.t("Upload & Delete")}
          />

          {/* ← Stats Cards added here – shows on top for both tabs */}
          <Row className="mb-4">
            <Col xl="12">
              <StatsCards />
            </Col>
          </Row>

          {/* Tabs Navigation */}
          <Row className="mb-4">
            <Col xl="12">
              <Nav tabs className="nav-tabs-custom">
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => toggle("1")}
                  >
                    {props.t("Upload")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => toggle("2")}
                  >
                    {props.t("Delete")}
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
          </Row>

          {/* Tab Content */}
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Row>
                <Col xl="12">
                  <UploadSection />
                </Col>
              </Row>
            </TabPane>

            <TabPane tabId="2">
              <Row>
                <Col xl="12">
                  <DeleteSection />
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </Container>
      </div>
    </React.Fragment>
  )
}

ReportManager.propTypes = {
  t: PropTypes.func,
}

export default withTranslation()(ReportManager)
